import VerificationLayout from "../../components/verification/VerificationLayout.jsx"
import StatusBox from "../../components/verification/StatusBox.jsx"
import PatientDetails from "../../components/verification/PatientDetails.jsx"


export default function QRScanFailed() {
  return (
    <VerificationLayout>
      <StatusBox type="error" title="QR code scan failed" message="We couldn't read the QR code." />

      <div className="text-center mt-8 mb-8">
        <p>Please try again.</p>
        <p className="mt-2">If the problem continues, contact the support team.</p>
      </div>

      <div className="text-center text-lg mt-12">
        <p>You may close this window and scan the QR code again</p>
      </div>
    </VerificationLayout>
  )
}
